import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBar)?_c(VFooter,{staticClass:"pa-1",attrs:{"app":"","fixed":"","clipped-bottom":"","color":"primary darken-2","dark":""}},[_c('footer',{staticClass:"footer text-center d-block text-caption"},[(_vm.message)?_c(VIcon,[_vm._v("notification_important")]):_vm._e(),_vm._v(" "+_vm._s(_vm.message))],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }